import { useOrgSelfServeInfo } from '@hcs/self-serve-info';

import { OrgPricingAgileSuite } from '../OrgProductPricing';

import {
  OrgPricingConfirmDialog,
  OrgPricingConfirmDialogProdcutProps,
} from './OrgPricingConfirmDialog';

export const OrgPricingConfirmDialogAgileSuite = ({
  active,
  onAccept,
  onClose,
  capabilityKey,
}: OrgPricingConfirmDialogProdcutProps) => {
  const { data: ssInfo } = useOrgSelfServeInfo();
  const capabilityPricing = ssInfo?.self_serve_plan?.costs?.[capabilityKey];
  if (!capabilityPricing) return null;
  return (
    <OrgPricingConfirmDialog
      applicationKey="agile-suite"
      capabilityKey={capabilityKey}
      includedInTier={capabilityPricing.included_units}
      active={active}
      onAccept={onAccept}
      onClose={onClose}
      actionDescriptor={
        capabilityKey !== 'om-vr'
          ? 'that are successfully completed'
          : 'created'
      }
      unitDescriptorPlural="reports"
      disclaimer={
        capabilityKey !== 'om-vr'
          ? 'Onsite inspections, BPOs, and Agile Evaluations may also incur additional cancellation and/or rush charges.'
          : undefined
      }
    >
      <OrgPricingAgileSuite capabilityKey={capabilityKey} />
    </OrgPricingConfirmDialog>
  );
};
